import React from 'react'

const License = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/license',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g strokeWidth='1.2' fill='none' fillRule='evenodd'>
      <path
        d='M3.513 1.053H16.5c.518 0 1 .49 1 .944v15.111c0 .454-.482.945-1 .945h-13c-.518 0-1-.491-1-.945V1.998c0-.472.529-.945 1.013-.945z'
        stroke={primaryColor}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <g transform='translate(7 3.5)'>
        <path
          stroke={secondaryColor}
          strokeLinecap='round'
          d='M.5 5.5V11L3 9.069 5.5 11V5.5'
        />
        <circle stroke={primaryColor} cx={3} cy={3.5} r={3} />
      </g>
    </g>
  </svg>
)

export default License
